import React from "react";
import styled from "styled-components";

import { Button, color as colors } from "@workboard/wobo-ui";
import { useTranslation } from "react-i18next";

function Presets({
  className,
  // eslint-disable-next-line
  onChange = () => {},
  // eslint-disable-next-line
  onReset = () => {},
  // eslint-disable-next-line
  onDismiss = () => {},
  // eslint-disable-next-line
  onSubmit = () => {},
  ...props
}) {
  const { t } = useTranslation();
  return (
    <div className={className} {...props}>
      <Button onClick={onDismiss} variant="ghost">
        {t("Cancel")}
      </Button>
      <Button onClick={onSubmit} variant="primary">
        {t("Apply")}
      </Button>
    </div>
  );
}

export default styled(Presets)`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  padding: 0 16px 24px;

  ${Button} {
    margin: 8px 8px 0 0;

    &[data-selected="true"] {
      background: ${colors("--blue-200")};
    }
  }
`;
